import Swal from 'sweetalert2';
import '@/styles/plugins/sweetalert2.scss';

export default Swal;
